import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

import Header from '../../sections/Header/Header';
import Footer from '../../sections/Footer/Footer';
import TextContent from '../../components/Section/TextContent/TextContent';

import Splash1 from '../../../tmp/splash1.jpg';
import photoGirl1 from '../../../tmp/sara1.jpg';
import photoGirl2 from '../../../tmp/veronika1.jpg';
import photoGirl3 from '../../../tmp/kristina1.jpg';

import PreviewSlider from '../../components/Slider/PhotoSlider/PhotoSlider';

const Home = () => {

    const tempPreviewImages = [
        photoGirl1,
        photoGirl2,
        photoGirl3,
    ];

    const tempPreviewImages2 = [
        Splash1,
        photoGirl2,
        photoGirl3,
    ]

    const tempPreviewImages3 = [
        photoGirl2,
        Splash1,
        photoGirl3,
    ]

    const tempPreviewImages4 = [
        photoGirl3,
        photoGirl2,
        Splash1,
    ]

    useEffect(() => {
        window.scrollTo(0, 0)
    })

    return (
        <>
            <Header />
            <section 
                className="home-splash"
                style={{
                    backgroundImage: `url(${Splash1})`
                }}
            >
                <div className="main-wrap">
                    <div className="main-frame">
                        <div className="view-container">
                            <div className="intro">
                                <div className="intro-text">
                                    <p>We turn your fantasies into reality.</p>
                                    <p>Adult entertainment brand.</p>
                                </div>
                                <div className="intro-cta">
                                    <Link to={'/talent'}>Talent</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <TextContent content={
                <>
                    <p>
                        SADIDA Network, known as <u>All Day I Dream About Sex</u>, in reverse, is an adult entertainment consulting agency based in Rome, Italy. 
                        Our work is inspired by the rich history and opulent lifestyle of the Roman Empire. We are dedicated to bringing your deepest 
                        fantasies to life with a touch of Roman elegance and decadence.
                    </p>
                </>
            }
            title="The Agency"
            />
            <section className="photo-content">
                <div className="view-container">
                    <div className="photo-girl"
                        style={{backgroundImage:`url(${photoGirl1})`}}
                    ></div><div className="photo-girl"
                    style={{backgroundImage:`url(${photoGirl2})`}}
                    ></div><div className="photo-girl"
                    style={{backgroundImage:`url(${photoGirl3})`}}
                    ></div>
                </div>
            </section>
            <TextContent type="dark" content={
                    <>
                        <p> 
                            Our team of professionals will meticulously recreate your vision, ensuring every detail is perfect. 
                            From the ambiance to the colors, the feelings to the surroundings, we make sure you experience every second 
                            of your dream in the most vivid way possible.
                        </p>
                    </>
                }
                title = "What We Do"
            />
            <section className="title-bar">
                <div className="tb-name">
                    <span>Featured Talent</span>
                </div>
                <div className="tb-bar"></div>
            </section>
            <section className="talent-wall">
                <PreviewSlider col={4} images={tempPreviewImages} name={'Sara'} city={'Rome'} link={'/models/rome/sara'}/>
                <PreviewSlider col={4} images={tempPreviewImages2} name={'Veronika'} city={'Rome'} link={'/models/rome/veronika'} />
                <PreviewSlider col={4} images={tempPreviewImages3} name={'Denise'} city={'Milan'} link={'/models/milan/denise'} />
                <PreviewSlider col={4} images={tempPreviewImages4} name={'Kristina'} city={'Rome'} link={'/models/rome/kristina'} />
            </section>
            <Footer />
        </>
    )
}

export default Home;